import { action, computed, observable } from 'mobx';
import { Api } from '../api/Api';
import { DiaryPageDto } from '../api/generated';

import { IDiaryPageItem } from './DiaryPageItem';
import { DrinkDiaryPageItem } from './drink/DrinkDiaryPageItem';
import { MealDiaryPageItem } from './meal/MealDiaryPageItem';
import { TrainingDiaryPageItem } from './training/TrainingDiaryPageItem';
import { WaterDiaryPageItem } from './water/WaterDiaryPageItem';

export declare interface IDiaryPageStore {
  loading: boolean;
  date: Date;
  dateStr: string;
  items: IDiaryPageItem[];
  empty: boolean;
  next: () => void;
  previous: () => void;
  setDate: (date: Date) => void;
  refresh: () => Promise<any>;
}

export class DiaryPageStore implements IDiaryPageStore {

  @observable private _date : Date = new Date();
  @observable private _loading: boolean = true;
  @observable private _items: any[] = [];

  private readonly _api: Api;

  constructor(api: Api) {
    this._api = api;
  }

  @computed get date() {
    return this._date;
  }

  @computed get dateStr() {
    return this._date.toISOString().slice(0, 10);
  }

  @computed get loading() {
    return this._loading && this._items.every(item => !item.loading);
  }

  @computed get items() {
    return this._items;
  }

  @computed get empty() {
    return this._items.length === 0;
  }

  @action public move(days: number) {
    const newDate = new Date(this._date.getTime());
    newDate.setDate(newDate.getDate() + days);
    this.setDate(newDate);
  }

  @action public next() {
    this.move(1);
  }

  @action public previous() {
    this.move(-1);
  }

  @action public setDate(date: Date) {
    this._date = date;
    this.refresh();
  }

  @action public reset() {
    this.setDate(new Date());
  }

  @action public refresh() {
    this._loading = true;
    return this._api.getDiaryPage(this.date).then((diaryPage: DiaryPageDto) => {
      window.console.log(diaryPage);
      const items: IDiaryPageItem[] = [];
      (diaryPage.meals || []).forEach(item => items.push(new MealDiaryPageItem(this._api, item)));
      (diaryPage.drinks || []).forEach(item => items.push(new DrinkDiaryPageItem(this._api, item)));
      (diaryPage.waters || []).forEach(item => items.push(new WaterDiaryPageItem(item)));
      (diaryPage.trainings || []).forEach(item => items.push(new TrainingDiaryPageItem(item)));
      // @TODO: sort items
      this._items = items;
      this._loading = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/diary/DiaryPageStore.ts